import React, { Component, Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

import Loading from 'components/Loading/Loading';
import { browserHistory, withRouter } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { fetchTeacherListing } from 'actions/Teacher/listingActions';

import ListingDetails from './Details';
import ListingStatus from '../ListingStatus';

import './style.css';

class TeacherScheduleListingEdit extends Component {
  constructor(props) {
    super(props);

    this.fetchListing();
  }

  fetchListing = () => {
    const {
      routeParams: { id },
      fetchTeacherListing: fetchTeacherListingFn,
    } = this.props;
    fetchTeacherListingFn(id);
  }

  handleBack = () => {
    browserHistory.push('/teacher/schedule/listings');
  }

  render() {
    const { listing, getListingStatus } = this.props;
    const isLoading = isEmpty(listing) || getListingStatus === 'LOADING';

    return (
      <div className="teacher-listing-edit full-height card">
        <div className="px-4 px-lg-5 pt-4 pt-lg-5">
          <div
            className="teacher-listing-edit__back d-flex align-items-center btn-cursor mb-4"
            onClick={this.handleBack}
          >
            <img
              className="teacher-listing-edit__back-icon"
              src="/assets/right-chevron.svg"
              alt="back"
            />
            <span className="ml-2">Back to Listings</span>
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <Fragment>
              <div className="d-flex align-items-center mb-2">
                <h5 className="m-0">{listing.service.description}</h5>
                <ListingStatus className="ml-5" status={listing.status} />
              </div>
              <p className="teacher-listing-edit__category m-0">
                {listing.service.category.description}
              </p>
            </Fragment>
          )}
        </div>
        {!isLoading && <ListingDetails listing={listing} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    listing: state.teacher.listing,
    getListingStatus: state.teacher.getListingStatus
  };
}

export default compose(
  withRouter,
  connect(mapStateToProps, {
    fetchTeacherListing
  })
)(TeacherScheduleListingEdit);



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Listings/Edit/index.js